import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EmailPreview from "./emailPreview";
import AchievementService from "../../services/AchievementService";
const AchievementEmailPreview = (props) => {
    const loadSubject = () => AchievementService.getTemplatePreview(props.getSubject(), props.achievementTypeId, props.getSentAsSystem()).then((response) => response.result);
    const loadBody = () => AchievementService.getTemplatePreview(props.getBody(), props.achievementTypeId, props.getSentAsSystem()).then((response) => response.result);
    return (_jsx(EmailPreview, { getBody: loadBody, getSubject: loadSubject, modalId: props.modalId }));
};
export default AchievementEmailPreview;
